/* ==================================================
   JHC HOME FOOTER
================================================== */

document.addEventListener("DOMContentLoaded", () => {

  const button = document.querySelector("[data-back-to-top]");

  if (!button) return;

  const toggleButton = () => {

    if (window.scrollY > 400) {

      button.style.opacity = "1";
      button.style.visibility = "visible";
      button.style.transform = "translateY(0)";

    } else {

      button.style.opacity = "0";
      button.style.visibility = "hidden";
      button.style.transform = "translateY(15px)";

    }

  };

  toggleButton();

  window.addEventListener("scroll", toggleButton);

  button.addEventListener("click", () => {

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

  });

});